export default __webpack_public_path__ + "static/media/support.6bcb2c7d.bin";